<template>
  <div class="tabs-demo" v-loading="maskLoading">
    <vx-card title="">
      <div class="mt-5">
        <div class="management-title">
          <div class="management-tel">
            <el-input v-model="deptName" placeholder="机构名称/编码"></el-input>
          </div>
          <div class="management-tel">
            <el-input v-model="phone" placeholder="手机号"></el-input>
          </div>
          <div class="management-tel">
            <el-select v-model="status" placeholder="状态">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="management-tel">
            <el-select v-model="deptType" placeholder="机构分类">
              <el-option
                v-for="item in deptTypeIdlist"
                :key="item.id"
                :label="item.customerName"
                :value="item.customerCode"
              >
              </el-option>
            </el-select>
          </div>
          <div class="management-tel">
            <el-select v-model="categoryClientType" @change="handleKhType" placeholder="客户类别">
              <el-option
                v-for="item in categoryIdlist"
                :key="item.id"
                :label="item.customerName"
                :value="item.customerCode"
              >
              </el-option>
            </el-select>
          </div>
          <div class="management-tel">
            <el-select v-model="customerClientType" placeholder="客户类型">
              <el-option
                v-for="item in customerTypelist"
                :key="item.id"
                :label="item.customerName"
                :value="item.customerCode"
              >
              </el-option>
            </el-select>
          </div>
          <div class="management-tel">
            <el-select v-model="customerStoreType" placeholder="门店类别">
              <el-option
                v-for="item in categoryStoreIdlist"
                :key="item.id"
                :label="item.customerName"
                :value="item.customerCode"
              >
              </el-option>
            </el-select>
          </div>
          <div class="management-tel">
            <el-select
              v-model="province"
              placeholder="省"
              @change="getProvincial($event)"
            >
              <el-option
                v-for="item in Provincial"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="management-tel">
            <el-select
              v-model="city"
              placeholder="市"
              @change="geturban($event)"
            >
              <el-option
                v-for="item in urban"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="management-tel">
            <el-select v-model="county" placeholder="区">
              <el-option
                v-for="item in areas"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="management-tel">
<!--            <el-button-->
<!--              type="primary"-->

<!--              @click="structure(0)"-->
<!--              >层级关系查询</el-button-->
<!--            >-->
            <el-button
                    style="width: 100px"
                    type="primary"

                    @click="searchList(1)"
            >查询</el-button
            >
            <el-button @click="Reset" style="width: 80px" type="info"
              >重置</el-button
            >
          </div>
        </div>
        <div class="management-body" v-if="filtering('dept:view')">
          <el-table :data="tableData" v-loading="isLoading" border style="width: 100%" lazy  :load="lazyLoad"  :tree-props="{ children: 'children',hasChildren: 'hasChild' }"
              row-key="id">
              <el-table-column prop="data.deptName" label="名称" width="400">
              </el-table-column>
            <el-table-column prop="data.deptCode" width="200" label="编号" >
            </el-table-column>
              <el-table-column prop="data.phone" label="联系方式" width="120">
              </el-table-column>
              <el-table-column prop="data.provinceName" label="省" width="120">
              </el-table-column>
              <el-table-column prop="data.cityName" label="市" width="120">
              </el-table-column>
              <el-table-column prop="data.countyName" label="区" width="120">
              </el-table-column>
              <el-table-column prop="data.parentName" label="上级" width="120">
              </el-table-column>
              <el-table-column prop="data.deptTypeName" label="分类" width="120">
              </el-table-column>
              <el-table-column
                      prop="data.categoryName"
                      label="类别"
                      width="120"
              >
              </el-table-column>
              <el-table-column
                      prop="data.customerName"
                      label="类型"
                      width="200"
              >
              </el-table-column>
              <el-table-column
                      prop="data.priceName"
                      label="价格模板"
                      width="120"
              >
              </el-table-column>
              <el-table-column
                      align="center"
                      prop="data.status"
                      :formatter="formtype"
                      label="状态"
              >
                <template slot-scope="scope"> <el-tag :type="scope.row.data.status === 3?'danger':'success'" size="mini" >{{scope.row.data.status === 1?'已启用':'已停用'}}</el-tag> </template>
              </el-table-column>
              <el-table-column prop="data.remarks" label="备注" width="400">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template #default="scope">
                  <el-button
                          @click.native="routing(scope.row.data, '2')"
                          type="text"
                          size="small"
                          v-if="filtering('dept:update')"
                  >编辑</el-button
                  >
                  <el-dropdown class="hovbersf">
                    <el-button type="text" size="small" style="margin-left: 10px"
                    >更多</el-button
                    >
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                              @click.native="routing(scope.row.data, '0')"
                              v-if="filtering('dept:add')"
                      >新建下级部门</el-dropdown-item
                      >
                      <el-dropdown-item
                              @click.native="routing(scope.row.data, '1')"
                              v-if="filtering('dept:add')"
                      >新建平级部门</el-dropdown-item
                      >
                      <el-dropdown-item
                              v-if="scope.row.data.status == 1 && filtering('dept:delete')"
                              @click.native="Deactivate(scope.row.data, 'stop')"
                      >停用</el-dropdown-item
                      >
                      <el-dropdown-item
                              v-if="scope.row.data.status == 3 && filtering('dept:delete')"
                              @click.native="Deactivate(scope.row.data, 'start')"
                      >启用</el-dropdown-item
                      >
                      <el-dropdown-item
                              @click.native="Deletcode(scope.row.data)"
                              v-if="filtering('dept:delete')"
                      >删除</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
          </el-table>
          <div v-show="showPagination" style="margin: 20px 0 0 0; text-align: center">
            <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    layout="total, prev, pager, next"
                    :total="pageTotal"
            >
            </el-pagination>
          </div>
        </div>
        <vs-prompt
          @close="closeModal"
          title="机构信息"
          :active.sync="dialogVisible"
          class="form_box"
        >
          <div class="con-exemple-prompt">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="上级机构" prop="parentName" v-if="Showsuperior">
<!--                <el-cascader-->
<!--                  placeholder="上级机构"-->
<!--                  :options="superior"-->
<!--                  :props="cascaderProps"-->
<!--                  style="width: 300px"-->
<!--                  @change="getcascadercode"-->
<!--                  v-model="ruleForm.parentIds"-->
<!--                  :show-all-levels="false"-->
<!--                  ref="cascader"-->
<!--                  filterable-->
<!--                  clearable-->
<!--                ></el-cascader>-->
                <el-input  v-model="ruleForm.parentName" :disabled="true" style="width: 400px;overflow: hidden">
                  <el-button @click="openTreeModal" slot="append" style="background-color: #409EFF;color: #fff;height: 40px;border-top-left-radius: 0;border-bottom-left-radius: 0"  :icon="btnIcon">{{btnText}}</el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="机构名称" prop="deptName">
                <el-input
                  style="width: 400px"
                  v-model="ruleForm.deptName"
                  placeholder="请输入机构名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="phone">
                <el-input

                  style="width: 400px"
                  maxlength="11"
                  v-model="ruleForm.phone"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构分类" prop="deptType">
                <el-select

                  style="width: 400px"
                  v-model="ruleForm.deptType"
                  placeholder="请选择"
                  @change="getjgfl($event)"
                >
                  <el-option
                    v-for="item in deptTypeIdlist"
                    :key="item.id"
                    :label="item.customerName"
                    :value="item.customerCode"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="显示排序" prop="orderNum">
                <el-input
                  style="width: 400px"
                  v-model="ruleForm.orderNum"
                  placeholder="请输入排序"
                ></el-input>
              </el-form-item>
              <el-form-item label="所属区域" prop="region">
                <el-cascader
                  style="width: 400px"
                  v-model="Tertiaryaddress"
                  @change="getProvinmechanism($event)"
                  :props="props"
                  filterable
                  clearable
                ></el-cascader>
              </el-form-item>
              <el-form-item label="机构地址" prop="address">
                <el-input
                  style="width: 400px"
                  v-model="ruleForm.address"
                  placeholder="请输入机构地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="remarks">
                <el-input
                  style="width: 400px"
                  type="textarea"
                  v-model="ruleForm.remarks"
                  placeholder="请输入备注"
                ></el-input>
              </el-form-item>
              <div v-if="ruleForm.deptType == 'KH'">
                <div class="management-customer">客户类型</div>
                <el-form-item label="客户类别" prop="categoryClientType">
                  <el-select
                    style="width: 400px"
                    @change="handleKeClass"
                    v-model="ruleForm.categoryClientType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in keClass"
                      :key="item.customerCode"
                      :label="item.customerName"
                      :value="item.customerCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客户类型" prop="customerClientType">
                  <el-select
                    style="width: 400px"
                    v-model="ruleForm.customerClientType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in keType"
                      :key="item.customerCode"
                      :label="item.customerName"
                      :value="item.customerCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="价格模板" prop="priceId">
                  <el-select
                    style="width: 400px"
                    v-model="ruleForm.priceId"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in priceModellist"
                      :key="item.id"
                      :label="item.priceName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div v-if="ruleForm.deptType == 'MD'">
                <div class="management-customer">门店信息</div>

                <el-form-item label="门店类型" prop="categoryStoreType">
                  <el-select
                    style="width: 400px"
                    v-model="ruleForm.categoryStoreType"
                    placeholder="请选择"
                    @change="getBStoretype($event)"
                  >
                    <el-option
                      v-for="item in Storetypelist"
                      :key="item.id"
                      :label="item.customerName"
                      :value="item.customerCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <div v-if="ruleForm.categoryStoreType == 'MDLXFZY'">
                  <el-form-item label="门店类别" prop="customerStoreType">
                    <el-select
                      style="width: 400px"
                      v-model="ruleForm.customerStoreType"
                      placeholder="请选择"
                      @change="getBoling($event)"
                    >
                      <el-option
                        v-for="item in catfjghdjlist"
                        :key="item.id"
                        :label="item.customerName"
                        :value="item.customerCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="所属客户" prop="customerClientCode">
                    <el-select
                      style="width: 400px"
                      v-model="ruleForm.customerClientCode"
                      placeholder="请选择"
                      filterable
                      remote
                      :remote-method="remoteMethod"
                    >
                      <el-option
                        v-for="item in cusUserIdlist"
                        :key="item.id"
                        :label="item.name"
                        :value="item.outCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div v-if="ruleForm.deptTypeId == '4'">
                <div class="management-customer">仓库编码</div>
                <div >
                  <el-form-item label="仓库编码" prop="warehouse">
                        <el-input
                      style="width: 400px"
                      v-model="ruleForm.warehouse"
                      placeholder="请输入仓库编码"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
          <div class="exemple_footer">
            <el-button
              type="primary"
              style="width: 100px"
              @click="getadd()"
              plain
              >保存</el-button
            >
            <el-button style="width: 100px" @click="closeModal"
              >取消</el-button
            >
          </div>
          <el-drawer custom-class="demo-drawer" title="选择上级机构" direction="rtl"  append-to-body :visible.sync="treeModal" :before-close="treeClose">
            <div style="position: relative;padding: 0 20px 0px 20px;box-sizing: border-box">
              <el-tree style="height:calc(100vh - 140px);overflow-y: scroll" :accordion="true"   show-checkbox :data="treeData"  :load="loadNode" lazy :props="treeProps" :check-strictly="true"   node-key="id" highlight-current ref="tree">
              </el-tree>
              <div style="margin-top: 20px">
                <el-button @click="checkJg" style="width: 100%" type="primary" >提交</el-button>
              </div>
            </div>
          </el-drawer>
        </vs-prompt>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { OrderApi } from "@/modules/accounts/getapi";
var validatorPhone = function (rule, value, callback) {
  if (value === "") {
    callback(new Error("手机号不能为空"));
  } else if (!/^1[3|4|5|7|8][0-9]\d{8}$/.test(value)) {
    callback(new Error("手机号格式错误"));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      btnText:'选择机构',
      btnIcon:'el-icon-search',
      treeData:[],
      treeProps:{
        children: "children",
        label: "name",
      },
      treeModal:false,//上级机构树弹窗
      tempInfoObj:{},
      page:1,//精准查询分页页码
      pageTotal:1,//精准查询总数
      showPagination:false,//精准查询分页器
      isLoading:false,
      maskLoading:false,
      tempJson:{},//临时存储编辑时接口返回的Json
      deptName: "",
      phone: "",
      status: "",
      deptType: "",
      deptTypeIdlist: [],
      categoryClientType: "",
      categoryIdlist: [],
      customerStoreType: "",
      categoryStoreIdlist: [],
      customerClientType: "",
      customerTypelist: [],
      pageNum: 1,
      pageSize: 10,
      loaded: false,
      tableData: [],
      shilist: [],
      qulist: [],
      options: [
        {
          value: "1",
          label: "启用",
        },
        {
          value: "3",
          label: "停用",
        },
      ],
      dialogVisible: false, //新增编辑弹框
      ruleForm: {
        id: "", //数据id
        parentId: "", //上级机构
        parentIds: [],
        parentName: "",
        deptName: "", //机构名称
        phone: "", //手机号
        deptType: "", //机构分类
        orderNum: "", //排序
        province: "", //省
        city: "", //市
        county: "", //区

        remarks: "", //备注
        address: "", //机构地址

        categoryClientType: "", //客户类别
        customerClientType: "", //客户类型
        priceId: "", //价格模板Id
        priceName: "", //价格模板名称
        categoryStoreType: "", //门店类型
        customerStoreType: "", //门店类别
        customerClientCode: "", //所属客户
        warehouse:'',//仓库编码
      },
      catfjghdjlist: [],
      Tertiaryaddress: [],
      customerStoreTypelist: [],
      cusUserIdlist: [],
      priceModellist: [],
      Storetypelist: [],
      cascaderProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true,
        lazy:true,
        async lazyLoad(node,resolve){
          console.log(node);
          let res = await OrderApi.structure({},node.data.id);
          resolve(res.data);
        }
      },
      rules: {
        parentName: [
          { required: true, message: "请选择上级机构", trigger: "blur" },
        ],
        deptName: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
        deptType: [
          { required: true, message: "请选择机构分类", trigger: "blur" },
        ],
        //客户类型
        categoryClientType: [
          { required: true, message: "请选择客户类别", trigger: "blur" },
        ],
        customerClientType: [
          { required: true, message: "请选择客户类型", trigger: "blur" },
        ],
        // priceModel: [
        //   { required: true, message: "请选择价格模板", trigger: "blur" },
        // ],

        //门店信息
        categoryStoreType: [
          { required: true, message: "请选择门店类型", trigger: "blur" },
        ],
        customerStoreType: [
          { required: true, message: "请选择门店类别", trigger: "blur" },
        ],
        //仓库编码
        warehouse: [
          { required: true, message: "请输入仓库编码", trigger: "blur" },
        ],

        // cusUserId: [
        //   { required: true, message: "请选择所属客户", trigger: "blur" },
        // ],
      },
      Provincial: [], //省列表
      province: "", //省名称
      urban: [], //市列表
      city: "", //市名称
      areas: [], //区列表
      county: "", //区名称
      input: "",
      superior: [], //上级机构
      props: {
        lazy: true,
        async lazyLoad(node, resolve, data) {
          const level = node.level;
          if (level === 0) {
            let list = [];
            let res = await OrderApi.Provincial({ pid: "0" });
            res.data.map((item) => {
              let obj = {
                label: item.name,
                value: item.id,
                leaf: false,
              };
              list.push(obj);
            });
            resolve(list);
          } else if (level === 1) {
            let list = [];
            let res = await OrderApi.Provincial({ pid: node.data.value });
            res.data.map((item) => {
              let obj = {
                label: item.name,
                value: item.id,
                leaf: false,
              };
              list.push(obj);
            });
            resolve(list);
          } else if (level === 2) {
            let list = [];
            let res = await OrderApi.Provincial({ pid: node.data.value });
            res.data.map((item) => {
              let obj = {
                label: item.name,
                value: item.id,
                leaf: true,
              };
              list.push(obj);
            });
            resolve(list);
          }
        },
      },
      keType:[],
      keClass:[],
      Createoredit: 0, //0新建 1编辑
      scustomeruid: "",
      Showsuperior:true,//是否显示上级机构
    };
  },
  created() {
    this.getpevern();
    this.structure(0);
  },
  methods: {
    checkJg(){
      if(this.$refs.tree.getCheckedNodes().length > 1){
        this.$message.error('只能选择一个机构');
        return false;
      }
      if(this.$refs.tree.getCheckedNodes().length === 0){
        this.$message.error('请选择机构');
        return false;
      }
      let parentId = this.$refs.tree.getCheckedNodes()[0].id;
      let parentName = this.$refs.tree.getCheckedNodes()[0].name;
      if(parentId === this.ruleForm.id){
        this.$message.error('当前机构不可选');
        return false;
      }


      this.ruleForm.parentIds = parentId;
      this.ruleForm.parentName = parentName;
      this.treeModal = false;
    },
    resetChecked(){
      this.$refs.tree.setCheckedKeys([]);
    },
    treeClose(){
      this.treeModal = false;
      this.resetChecked();
    },
    async loadNode(node,resolve){
      let id;
      if(node.level === 0){
        id = 0
      }else{
        id = node.data.id
      }

      let res = await OrderApi.structure({},id);
      console.log(res.data);
      resolve(res.data);
    },
    //选择上级机构弹窗
    openTreeModal(){
      this.treeModal = true;
    },
    //编辑时客户类别-客户类型联动
    handleKeClass(val){
      if(val !== this.tempInfoObj.categoryClientType){
        this.ruleForm.customerClientType = '';
      }
      let baseData =  this.categoryIdlist.find(item=>{
        return item.customerCode === val
      })
      let list = [];
      this.allCustomerTypelist.forEach(item=>{
        if(item.parentId === baseData.id){
          list.push(item);
        }
      })
      this.keType=list;
    },
    //一级精准查询
    async searchList(page){
      this.page = page;
      let data = {
        size:10,
        current:page,
        data:{
          deptName: this.deptName, //机构名称或编码
          phone: this.phone, //手机号
          status: this.status, //状态：status   1 启用 2 禁用 3 停用
          deptType: this.deptType, //机构分类
          categoryClientType: this.categoryClientType, //客户类别
          customerStoreType: this.customerStoreType, //门店类别
          customerClientType: this.customerClientType, //客户类型
          province: this.province, //省
          city: this.city, //市
          county: this.county, //区县
        }
      };
      this.tableData = [];

      let res = await OrderApi.getList(data);
      res.result.records.forEach(item=>{
        item.hasChild = false;
      })
      this.tableData = res.result.records;
      this.pageTotal = res.result.total;
      this.showPagination = true;
    },
    //精准查询分页
    handleCurrentChange(val){
      this.page = val;
      this.searchList(this.page);
    },
    //列表页懒加载
    async lazyLoad(tree, treeNode, resolve) {
      console.log(tree);
      let id = tree.id;
      this.isLoading = true;
      let data = {
        deptName: this.deptName, //机构名称或编码
        phone: this.phone, //手机号
        status: this.status, //状态：status   1 启用 2 禁用 3 停用
        deptType: this.deptType, //机构分类
        categoryClientType: this.categoryClientType, //客户类别
        customerStoreType: this.customerStoreType, //门店类别
        customerClientType: this.customerClientType, //客户类型
        province: this.province, //省
        city: this.city, //市
        county: this.county, //区县
      };
      let res = await OrderApi.structure(data,id);
      resolve(res.data);
      // this.total = res.data.total;
      this.isLoading = false;
    },
    closeModal(){
      this.dialogVisible = false;
    },
    //筛选-根据客户类别id，对应的客户类型
    handleKhType(val){
      console.log(val);
      let baseData =  this.categoryIdlist.find(item=>{
        return item.customerCode === val
      })
      let list = [];
      this.allCustomerTypelist.forEach(item=>{
          if(item.parentId === baseData.id){
            list.push(item);
          }
      })
      this.customerTypelist=list;
    },
    //机构分类
    async getjgfl(e) {
      console.log(e);
      this.ruleForm.categoryClientType = ""; //客户类别
      this.ruleForm.customerClientType = ""; //客户类型
      this.ruleForm.priceId = null; //价格模板
      this.ruleForm.priceName = ""; //价格模板
      this.ruleForm.categoryStoreType = ""; //门店类型
      this.ruleForm.customerStoreType = ""; //门店类别
      this.ruleForm.customerClientCode = ""; //所属客户
      if (e == "MD") {
        //门店类型
        let str = await OrderApi.Deactivatelist({ cusType: 5,type:2 });
        this.Storetypelist = str.data;
      }
      if(e === "KH"){
        this.getTemplate();
      }
    },
    //获取价格模板
    async getTemplate(e) {
      this.priceModellist = [];
      this.ruleForm.priceId = "";
      this.ruleForm.priceName = "";
      let data = {
        pageNum:1,
        pageSize:500
      };
      let res = await OrderApi.getPriceTemplate(data);
      this.priceModellist = res.result.list;
    },
    //获取列表
    async structure(id) {
      this.isLoading = true;
      this.showPagination = false;
      let data = {
          deptName: this.deptName, //机构名称或编码
          phone: this.phone, //手机号
          status: this.status, //状态：status   1 启用 2 禁用 3 停用
        deptType: this.deptType, //机构分类
          categoryClientType: this.categoryClientType, //客户类别
          customerStoreType: this.customerStoreType, //门店类别
          customerClientType: this.customerClientType, //客户类型
          province: this.province, //省
          city: this.city, //市
          county: this.county, //区县
      };
      console.log(id);
      let res = await OrderApi.structure(data,id);
      console.log(res.data);
      this.tableData = res.data;
      this.total = res.data.total;
      this.isLoading = false;
    },
    //判断状态
    formtype(row) {
      if (row.data.status == 1) {
        console.log(row);
        return "启用";
      } else if (row.data.status == 3) {
        return "停用";
      }
    },
    //获取省 机构分类
    //0：机构分类 3：客户类别 4：客户类型 2：门店类别
    async getpevern() {
      //省
      let data = {
        pid: "0",
      };
      let res = await OrderApi.Provincial(data);
      this.Provincial = res.data;
      //机构分类
      let str = await OrderApi.Deactivatelist({ cusType: 0,type:2});
      this.deptTypeIdlist = str.data;
      //客户类别
      let strkh = await OrderApi.Deactivatelist({ cusType: 4,type:2 });
      this.categoryIdlist = strkh.data;
      this.keClass = strkh.data;
      //客户类型
      let strlx = await OrderApi.Deactivatelist({ cusType: 2,type:2 });
      this.allCustomerTypelist = strlx.data;
      this.keType = strlx.data;
      //门店类别
      let strmd = await OrderApi.Deactivatelist({ cusType: 3,type:2 });
      this.categoryStoreIdlist = strmd.data;
    },
    //门店类型
    async getBStoretype(e) {
      console.log(e);
      if (e === 'MDLXFZY') {
        this.catfjghdjlist = [];
        //门店类别
        let strmd = await OrderApi.Deactivatelist({
          cusType: 2,
          type:2
        });
        this.catfjghdjlist = strmd.data;
      }
      console.log(this.ruleForm.categoryStoreType);
    },
    //门店类别
    async getBoling(e) {
      console.log(e);
      this.scustomeruid = e;
      let strmd = await OrderApi.Belonging({ type:e });
      this.cusUserIdlist = strmd.data;
    },
    //所属客户
    async remoteMethod(e) {
      let result = this.catfjghdjlist.find(item=>{
        return item.customerCode === this.ruleForm.customerStoreType
      })
      let strmd = await OrderApi.Belonging({ type:result.customerName,name: e });
      this.cusUserIdlist = strmd.data;
    },
    //点击省
    async getProvincial(e) {
      this.city = "";
      this.urban = [];
      this.county = "";
      this.areas = [];
      let data = {
        pid: e,
      };
      let res = await OrderApi.Provincial(data);
      this.urban = res.data;

      console.log(e, this.province);
    },
    //下级机构选择时 点击省
    async getProvinmechanism(e) {
      console.log(e);
    },
    //点击市
    async geturban(e) {
      this.county = "";
      this.areas = [];
      let data = {
        pid: e,
      };
      let res = await OrderApi.Provincial(data);
      this.areas = res.data;
    },
    //重置
    Reset() {
      this.province = ""; //清空省名称
      this.city = ""; //清空市名称
      this.urban = []; //清空市列表
      this.county = ""; //清空区名称
      this.areas = []; //清空区列表
      this.categoryClientType = "";
      this.customerStoreType = "";
      this.customerClientType = "";
      this.deptName = "";
      this.deptType = "";
      this.phone = "";
      this.status = "";
      this.showPagination = false;
      this.page = 1;
      this.structure(0);
    },
    //停用
    Deactivate(e, type) {
      if(e.updateStatus === 0){
        this.$message.error('当前机构状态,不可进行启停操作');
        return false;
      }
      if (type === 'stop') {  //启用
        this.open("确定停用该账号,该机构所属下级将全部停用", "stop", e);
      } else {
        this.open("确定启用该账号", "start", e);
      }
    },
    //删除
    Deletcode(e) {
      if(e.updateStatus === 0){
        this.$message.error('当前机构状态,不可进行删除操作');
        return false;
      }
      this.open("确定删除该账号,该机构所属下级将全部删除", "delete", e);
    },
    //弹框操作
    open(text, type, e) {
      this.$confirm(text, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
      })
        .then(() => {
          if (type === "stop") {
            this.getfunction(e.id,"stop");
          } else if (type === "start") {

            this.getfunction(e.id,"start");
          } else if (type === "delete") {

            this.getfunction(e.id,"delete");
          }
        })
        .catch(() => {});
    },
    async getfunction(data,type) {
      var res = null;
      if (type === "stop") {
        res = await OrderApi.stopDept(data);
      } else if (type === "start") {
         res = await OrderApi.startDept(data);
      } else if (type === "delete") {
         res = await OrderApi.delDept(data);
      }
      if (res.code === 200) {
        this.$message({
          type: "success",
          message: "成功!",
        });
        this.tableData = [];
        this.structure(0);

      } else {
        this.$message({
          type: "error",
          message: res.data,
        });
      }
    },
    //新建下级部门 新建平级部门 编辑
    async routing(e, type) {
      console.log(type);
      this.ruleForm.id = ""; //数据id
      this.ruleForm.parentId = ""; //上级机构
      this.ruleForm.parentIds = ""; //上级机构
      this.ruleForm.parentName = ""; //上级机构
      this.ruleForm.deptName = ""; //机构名称
      this.ruleForm.phone = ""; //手机号
      this.ruleForm.deptType = ""; //机构分类
      this.ruleForm.orderNum = ""; //排序
      this.ruleForm.province = ""; //省
      this.ruleForm.city = ""; //市
      this.ruleForm.county = ""; //区
      this.ruleForm.remarks = ""; //备注
      this.ruleForm.address = ""; //机构地址

      this.ruleForm.categoryClientType = ""; //客户类别
      this.ruleForm.customerClientType = ""; //客户类型
      this.ruleForm.priceId = ""; //价格模板
      this.ruleForm.priceName = ""; //价格模板

      this.ruleForm.categoryStoreType = ""; //门店类型
      this.ruleForm.customerStoreType = ""; //门店类别
      this.ruleForm.customerUserId = ""; //所属客户
      this.ruleForm.id = e.deptId;
      this.ruleForm.warehouse='';

      this.Tertiaryaddress = [];



      if (type == "0") {
        //下级机构
        //获取上级机构
        let res = await OrderApi.Superiororganization({ id: e.id });
        console.log(res);
        this.superior = res.data;
        this.Createoredit = 0;
        this.Showsuperior=true;
        this.$nextTick(()=>{
          this.btnText = '选择机构';
          this.btnIcon = 'el-icon-search';
        })

      } else if (type == "1") {
        //平级机构
        let res = await OrderApi.Superiororganization({ id: e.parentId });
        console.log(res);
        this.superior = res.data;
        this.Createoredit = 0;
        if(e.parentId==0){
          this.Showsuperior=false;
        }else{
          this.Showsuperior=true;
        }

      } else if (type == "2") {
        this.$nextTick(()=>{
          this.btnText = '修改机构';
          this.btnIcon = 'el-icon-edit';
        })

        //编辑
        this.maskLoading = true;
        this.Createoredit = 1;
        //获取详情
        let response = await OrderApi.getInfo(e.id);
        this.tempInfoObj = JSON.parse(JSON.stringify(response.data));//深拷贝缓存info为客户类别联动使用
        let json =response.data;
        if(json.categoryClientType){
          let baseData =  this.keClass.find(item=>{
            return item.customerCode === json.categoryClientType
          })
          let list = [];
          this.allCustomerTypelist.forEach(item=>{
            if(item.parentId === baseData.id){
              list.push(item);
            }
          })
          this.keType=list;
        }
        //上级机构-门店的编辑条件
        // if(json.deptTypeId === '3'&& json.parentName === '总部' && json.customerClientType === 'PD'){
        //   this.parentDisabled = false
        // }
        //上级机构
        this.ruleForm.id = json.id; //数据id
        this.ruleForm.parentId = json.parentId; //上级机构
        this.ruleForm.warehouse = json.warehouse;
        this.ruleForm.parentIds = json.parentId;
        this.ruleForm.parentName = json.parentName; //上级机构
        this.ruleForm.deptName = json.deptName; //机构名称
        this.ruleForm.phone = json.phone; //手机号
        this.ruleForm.deptType = json.deptType; //机构分类
        if(json.parentId==0){
          this.Showsuperior=false;
        }else{
          this.Showsuperior=true;
        }
        if (json.deptType == "MD") {
          //门店
          //门店类型
          let str = await OrderApi.Deactivatelist({
            cusType: 5,
          });
          this.Storetypelist = str.data;
          if (json.categoryStoreType == "MDLXFZY") {
            //非直营
            this.scustomeruid = json.customerStoreType;
            let strmd = await OrderApi.Deactivatelist({
              cusType: 2,
              parentId: json.categoryStoreId,
            });
            this.catfjghdjlist = strmd.data;
            let str = await OrderApi.Belonging({
              id: json.customerStoreType,
              clientId: json.customerUserId,
            });
            this.cusUserIdlist = str.data;
          }
          this.ruleForm.categoryStoreType = json.categoryStoreType; //门店类型
          this.ruleForm.customerStoreType = json.customerStoreType; //门店类别
          this.ruleForm.customerClientCode = json.customerStoreName; //所属客户
          this.tempJson = json;
        } else if (json.deptType == "KH") {
          //客户
          let data = {
            parentId: e.customerClientType,
            ascriptionCode: "价格模板",
          };
          // let str = await OrderApi.Deactivatelist(data);
          // this.priceModellist = str.data;
          await this.getTemplate();
          this.ruleForm.categoryClientType = json.categoryClientType; //客户类别
          this.ruleForm.customerClientType = json.customerClientType;//客户类型
          this.ruleForm.priceId = json.priceId; //价格模板id
          this.ruleForm.priceName = json.priceName; //价格模板名称
        }
        this.ruleForm.orderNum = json.orderNum; //排序
        this.ruleForm.province = json.province; //省
        this.ruleForm.city = json.city; //市
        this.ruleForm.county = json.county; //区
        this.ruleForm.remarks = json.remarks; //备注
        this.ruleForm.address = json.address; //机构地址

        if (json.county != "") {
          this.Tertiaryaddress.push(
            Number(json.province),
            Number(json.city),
            Number(json.county)
          );
        }
        this.maskLoading = false;
      }
      this.$nextTick(()=>{
        this.dialogVisible = true;
      })
    },
    //选择主机构
    getcascadercode(e) {
      this.ruleForm.parentName =
        this.$refs["cascader"].getCheckedNodes()[0].label;
      this.ruleForm.parentIds = JSON.parse(JSON.stringify(e));
      this.ruleForm.parentId = JSON.parse(JSON.stringify(e)).pop();
      console.log(this.ruleForm.parentIds, this.ruleForm.parentId);
    },
    //保存
    getadd() {
      console.log("保存");
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);
          if (this.Tertiaryaddress.length != 0) {
            this.ruleForm.province = this.Tertiaryaddress[0]; //省
            this.ruleForm.city = this.Tertiaryaddress[1]; //市
            this.ruleForm.county = this.Tertiaryaddress[2]; //区
          }
          this.ruleForm.parentIds = this.ruleForm.parentIds.toString();
          this.ruleForm.parentId = this.ruleForm.parentIds;
          if (this.Createoredit == 0) {
            this.getadddata(this.ruleForm);
          } else {
            this.Editorial(this.ruleForm);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //提交数据
    async getadddata(form) {
      let data = JSON.parse(JSON.stringify(form));
      // data.categoryStoreType = data.categoryStoreId;
      data.province = data.province ? data.province:null;
      data.city = data.city ? data.city:null;
      data.county = data.county ? data.county:null;
      delete data.categoryStoreId;
      if(data.customerClientType !== '' && data.customerClientType!== 'CVS' && data.customerClientType!== 'HW'&& data.customerClientType!== 'XT'){
        this.$message.error('新增客户类型只能选择 海外客户、CVS、新通路客户');
        return false;
      }
      if(data.categoryStoreType === 'MDLXFZY'){
        this.$message.error('门店只有直营店可以新增');
        return false;
      }
      if(data.priceId){
        console.log(this.priceModellist);
        var result = this.priceModellist.find(item=>{
          return item.id === data.priceId;
        })
        console.log(result);
        data.priceName = result.priceName;
      }
      // data.categoryStoreId = data.customerStoreType.customerCode;
      let res = await OrderApi.Subordinate(data);

      if (res.code == 200) {
        this.$message({
          showClose: true,
          message: "成功",
          type: "success",
        });
        this.structure();
        this.dialogVisible = false;
        location.reload();
      } else if (res.code == 403) {
        console.log()
      } else {
        this.$message({
          message: res.message,
          type: "error",
        });
      }
    },
    //编辑
    async Editorial(data) {
      let json = JSON.parse(JSON.stringify(data));
      var reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
      json.customerClientCode = reg.test(json.customerClientCode)?this.tempJson.customerClientCode:json.customerClientCode;

      let res = await OrderApi.Editorial(json);
      if (res.code == 200) {
        this.$message({
          showClose: true,
          message: "成功",
          type: "success",
        });
        this.structure();
        this.dialogVisible = false;
        location.reload();
      } else if (res.code == 403) {
        console;
      } else {
        this.$message({
          message: res.message,
          type: "error",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .demo-drawer__footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    /* justify-content: center; */
    background-color: #fff;
    z-index: 9999;
    text-align: center
  }
.form_box {
  /deep/ .vs-dialog-text {
    position: relative;
  }
}
.form_box {
  /deep/ .vs-component {
    display: none;
  }
  /deep/ footer {
    height: 60px;
  }
}
.management-title {
  display: flex;
  flex-wrap: wrap;
}
.management-tel {
  min-width: 200px;
  height: 40px;
  margin-right: 20px;
  margin-bottom: 20px;
  & > input {
    width: 100%;
    height: 100%;
  }
}
.management-body {
  width: 100%;
  min-height: 200px;
}
.con-exemple-prompt {
  width: 100%;
  height: 500px;
  overflow: auto;
}

.exemple_footer {
  width: 32%;
  height: 50px;
  position: absolute;
  z-index: 999999;
  bottom: -60px;
  right: 16px;
  background: white;
}
.management-customer {
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 20px;
}
</style>
